import { FormattedMessage } from "react-intl";

import { DEFAULT_VALUES, useLocalizedHref } from "@/libraries/web-framework";

const Dashboards = () => {
    return (
        <div>
            <h2>
                <FormattedMessage
                    id="JiraSoftwarePricingPage.modalContents.dashboards.title"
                    defaultMessage="Dashboards"
                />
            </h2>
            <p>
                <FormattedMessage
                    id="JiraSoftwarePricingPage.modalContents.dashboards.bodyOne"
                    defaultMessage="Dashboards visualize data from across any Jira product and project in a single place. Choose from dozens of pre-configured options or build your own custom dashboard."
                />
            </p>
            <p>
                <FormattedMessage
                    id="JiraSoftwarePricingPage.modalContents.dashboards.learnMore"
                    defaultMessage="<learnMore>Learn more</learnMore> about dashboards."
                    values={{
                        ...DEFAULT_VALUES,
                        learnMore: (chunks) => (
                            <a
                                data-event="clicked"
                                data-event-component="linkButton"
                                data-product-key="jiraSoftware"
                                // eslint-disable-next-line react-hooks/rules-of-hooks
                                href={useLocalizedHref(
                                    "/software/jira/guides/reports-dashboards/overview#what-is-a-system-dashboard"
                                )}
                            >
                                {chunks}
                            </a>
                        )
                    }}
                />
            </p>
        </div>
    );
};

export default Dashboards;
